import CityPageTemplate from "../city-template/CityPageTemplate";
import { hopkinsvilleConfig } from "./data";

export default function HopkinsvillePage() {
  return <CityPageTemplate config={hopkinsvilleConfig} />;
}